import { Fragment, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from 'src/components/ui/table';
import type { PlatformHealthRow } from '../types/operations.types';
import { PlatformHealthDetail } from './platform-health-detail';
import { VerificationStatusBadge } from './verification-status-badge';

type Props = {
  rows: PlatformHealthRow[];
};

export function PlatformHealthGrid({ rows }: Props) {
  const [expandedPlatform, setExpandedPlatform] = useState<string | null>(null);

  const togglePlatform = (platform: string) => {
    setExpandedPlatform((current) => (current === platform ? null : platform));
  };

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-8" />
          <TableHead>
            Platform
          </TableHead>
          <TableHead>
            Date
          </TableHead>
          <TableHead>
            Reconciliation status
          </TableHead>
          <TableHead>
            Overall status
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((row) => {
          const isOpen = expandedPlatform === row.platform;

          return (
            <Fragment key={row.platform}>
              <TableRow
                className="cursor-pointer"
                onClick={() => togglePlatform(row.platform)}
              >
                <TableCell className="py-3">
                  <span
                    className="flex size-6 items-center justify-center"
                    aria-hidden="true"
                  >
                    <ChevronRight
                      className={`size-4 text-gray-500 transition-transform ${isOpen ? 'rotate-90' : ''}`}
                    />
                  </span>
                </TableCell>
                <TableCell className="font-medium text-gray-900">
                  {row.platform}
                </TableCell>
                <TableCell>
                  {row.date}
                </TableCell>
                <TableCell>
                  <VerificationStatusBadge status={row.reconciliation_status} />
                </TableCell>
                <TableCell>
                  <VerificationStatusBadge status={row.overall_status} />
                </TableCell>
              </TableRow>
              {isOpen ? (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    className="p-0"
                  >
                    <PlatformHealthDetail
                      platform={row.platform}
                      checkDate={row.date}
                    />
                  </TableCell>
                </TableRow>
              ) : null}
            </Fragment>
          );
        })}
      </TableBody>
    </Table>
  );
}
